// Will be replaced during production builds - see prepare.sh
export const BuildVersion = "7896e1e";
